(() => {
  const root = document.querySelector('[data-jc-catalog]');
  if (!root) return;
  const registry = new Map(JSON.parse(root.querySelector('[data-equipment-registry]').textContent).map(item => [item.id, item]));
  const storageKey = 'jcsoapmachinery.quote.v1';
  const feedback = root.querySelector('[data-catalog-feedback]');
  let noticeTimer;
  const quantity = value => Math.max(1, Math.min(999, Math.floor(Number(value) || 1)));
  function clean(value) {
    if (!Array.isArray(value)) return [];
    const unique = new Map();
    value.slice(0, 300).forEach(line => {
      if (!line || !registry.has(line.id)) return;
      const equipment = registry.get(line.id);
      const model = equipment.models.includes(line.model) ? line.model : '';
      const key = line.id + ':' + model;
      const prior = unique.get(key);
      unique.set(key, { id: line.id, model, quantity: quantity((prior?.quantity || 0) + quantity(line.quantity)) });
    });
    return [...unique.values()];
  }
  function read() {
    try { return clean(JSON.parse(localStorage.getItem(storageKey) || '[]')); } catch { return []; }
  }
  let selection = read();
  function say(message) {
    window.clearTimeout(noticeTimer);
    feedback.textContent = message;
    noticeTimer = window.setTimeout(() => { feedback.textContent = ''; }, 5000);
  }
  function save() {
    try { localStorage.setItem(storageKey, JSON.stringify(selection)); }
    catch { say('Su navegador no permite guardar la selección. Mantenga esta página abierta para continuar.'); }
    update();
  }
  function summary() {
    const lines = selection.map((line, index) => {
      const equipment = registry.get(line.id);
      return `${index + 1}. ${equipment.title}\nConfiguración: ${line.model || 'Por definir con asesoría'}\nCantidad: ${line.quantity}\nReferencia: catálogo, página ${equipment.page}`;
    });
    const assistance = root.querySelector('[data-quote-assistance]')?.checked ? '\n\nServicio adicional: Necesito asesoría para la instalación de los equipos y capacitación del personal.' : '';
    return 'Solicitud de cotización · JC Soap Machinery\n\n' + (lines.join('\n\n') || 'Aún no hay equipos seleccionados.') + assistance;
  }
  function updateWhatsApp() {
    const body = root.querySelector('[data-quote-summary]');
    if (body) body.value = summary();
    const link = root.querySelector('[data-quote-whatsapp]');
    if (!link) return;
    const form = root.querySelector('#JcQuoteForm');
    const name = ['Nombre', 'Segundo nombre', 'Primer apellido', 'Segundo apellido'].map(key => form?.querySelector(`[name="contact[${key}]"]`)?.value.trim()).filter(Boolean).join(' ');
    const fullName = form?.querySelector('[data-contact-full-name]');
    if (fullName) fullName.value = name;
    const email = form?.querySelector('[name="contact[email]"]')?.value.trim();
    const phone = form?.querySelector('[name="contact[phone]"]')?.value.trim();
    const notes = form?.querySelector('[name="contact[Detalles del proyecto]"]')?.value.trim();
    let message = 'Hola, me gustaría solicitar una cotización.\n\n' + summary();
    if (name) message += '\n\nNombre: ' + name;
    if (email) message += '\nCorreo: ' + email;
    if (phone) message += '\nTeléfono: ' + phone;
    if (notes) message += '\n\nSobre mi proyecto: ' + notes;
    link.href = 'https://wa.me/573103432605?text=' + encodeURIComponent(message);
  }
  function update() {
    const total = selection.reduce((count, line) => count + line.quantity, 0);
    root.querySelectorAll('[data-quote-count]').forEach(element => { element.textContent = String(total); });
    const list = root.querySelector('[data-quote-list]');
    if (list) {
      list.replaceChildren();
      if (!selection.length) {
        const empty = document.createElement('p');
        empty.className = 'quote-empty';
        empty.textContent = 'Su cotización está vacía. Recorra el catálogo y agregue los equipos que le interesan.';
        list.append(empty);
      }
      selection.forEach((line, index) => {
        const equipment = registry.get(line.id);
        const row = document.createElement('article'); row.className = 'quote-row';
        const content = document.createElement('div');
        const title = document.createElement('h3'); title.textContent = equipment.title;
        const model = document.createElement('p'); model.textContent = line.model ? 'Modelo: ' + line.model : 'Configuración por definir con asesoría';
        const remove = document.createElement('button'); remove.type = 'button'; remove.className = 'quote-remove'; remove.textContent = 'Quitar equipo';
        remove.setAttribute('aria-label', 'Quitar ' + equipment.title + (line.model ? ', ' + line.model : ''));
        remove.addEventListener('click', () => {
          selection.splice(index, 1); save(); say('Equipo retirado de su cotización.');
          const remaining = list.querySelectorAll('.quote-remove');
          (remaining[Math.min(index, remaining.length - 1)] || root.querySelector('[data-continue-catalog]')).focus();
        });
        content.append(title, model, remove);
        const label = document.createElement('label'); label.textContent = 'Cantidad';
        const input = document.createElement('input'); input.type = 'number'; input.min = '1'; input.max = '999'; input.step = '1'; input.value = String(line.quantity);
        input.setAttribute('aria-label', 'Cantidad de ' + equipment.title + (line.model ? ', ' + line.model : ''));
        input.addEventListener('change', () => {
          line.quantity = quantity(input.value); save();
          const refreshed = list.querySelectorAll('input')[index]; refreshed?.focus();
        });
        label.append(input); row.append(content, label); list.append(row);
      });
    }
    updateWhatsApp();
  }
  root.querySelectorAll('[data-quote-item]').forEach(card => {
    card.querySelector('[data-add-quote]').addEventListener('click', () => {
      const input = card.querySelector('[data-item-quantity]');
      if (!input.reportValidity()) return;
      const id = card.dataset.quoteItem;
      const model = card.querySelector('[data-item-model]')?.value || '';
      const existing = selection.find(line => line.id === id && line.model === model);
      if (existing) existing.quantity = quantity(existing.quantity + quantity(input.value));
      else selection.push({ id, model, quantity: quantity(input.value) });
      save(); say('Añadido a su cotización: ' + registry.get(id).title + '.');
    });
  });
  const quoteForm = root.querySelector('#JcQuoteForm');
  quoteForm?.addEventListener('input', updateWhatsApp);
  quoteForm?.addEventListener('submit', event => {
    updateWhatsApp();
    if (!quoteForm.reportValidity()) { event.preventDefault(); return; }
    if (!selection.length) {
      event.preventDefault(); say('Agregue al menos un equipo antes de enviar su solicitud.');
      root.querySelector('[data-continue-catalog]').focus();
    }
  });
  root.querySelector('[data-quote-whatsapp]')?.addEventListener('click', event => {
    if (!selection.length) {
      event.preventDefault(); say('Agregue al menos un equipo a su cotización.');
      root.querySelector('[data-continue-catalog]').focus();
    } else if (!quoteForm?.reportValidity()) {
      event.preventDefault(); say('Complete los datos obligatorios antes de enviar su cotización.');
    } else updateWhatsApp();
  });
  const normalize = text => text.toLocaleLowerCase('es').normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  const search = root.querySelector('[data-catalog-search]');
  function filterCatalog() {
    if (!search) return;
    const query = normalize(search.value.trim()); let count = 0;
    root.querySelectorAll('[data-category-search]').forEach(card => {
      card.hidden = !normalize(card.dataset.categorySearch).includes(query); if (!card.hidden) count += 1;
    });
    root.querySelectorAll('.catalog-family').forEach(family => { family.hidden = ![...family.querySelectorAll('[data-category-search]')].some(card => !card.hidden); });
    root.querySelector('[data-search-status]').textContent = query ? (count === 1 ? '1 categoría encontrada' : `${count} categorías encontradas`) : '';
    root.querySelector('[data-no-results]').hidden = count !== 0;
  }
  search?.addEventListener('input', filterCatalog);

  // Tab-scoped navigation state contains only the catalog position and search term.
  const positionKey = 'jcsoapmachinery.catalog-position.v1';
  const returnKey = 'jcsoapmachinery.catalog-return.v1';
  let lastCategory = '';
  function readPosition() {
    try { return JSON.parse(sessionStorage.getItem(positionKey) || 'null'); }
    catch { return null; }
  }
  function rememberPosition(categoryKey = lastCategory) {
    if (!search) return;
    lastCategory = categoryKey;
    try {
      sessionStorage.setItem(positionKey, JSON.stringify({
        path: location.pathname, top: Math.max(0, Math.round(window.scrollY)),
        query: search.value.slice(0, 200), category: categoryKey
      }));
    } catch { /* Category anchors remain usable when storage is unavailable. */ }
  }
  root.querySelectorAll('[data-category-key]').forEach(link => {
    link.addEventListener('click', () => rememberPosition(link.dataset.categoryKey));
  });
  if (search) window.addEventListener('pagehide', () => rememberPosition());
  root.querySelectorAll('[data-catalog-back], [data-continue-catalog]').forEach(link => {
    const currentCategory = location.pathname.split('/').pop().replace(/\.html$/, '');
    const saved = readPosition();
    const fallback = saved?.category || currentCategory;
    if (/^[a-z0-9-]+$/.test(fallback) && !['maquinaria', 'cotizacion-de-maquinaria'].includes(fallback)) {
      link.hash = 'categoria-' + fallback;
    }
    link.addEventListener('click', event => {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      try {
        sessionStorage.setItem(returnKey, '1');
        const position = readPosition();
        // A fragment would start a second scroll after the saved position is restored.
        if (position?.path === link.pathname && Number.isFinite(position.top) && position.top >= 0) link.hash = '';
      } catch { /* Use the anchor fallback. */ }
    });
  });
  function restorePosition() {
    if (!search) return;
    let pending;
    try { pending = sessionStorage.getItem(returnKey); sessionStorage.removeItem(returnKey); }
    catch { return; }
    if (pending !== '1') return;
    const saved = readPosition();
    if (!saved || saved.path !== location.pathname || !Number.isFinite(saved.top) || saved.top < 0) return;
    search.value = typeof saved.query === 'string' ? saved.query.slice(0, 200) : '';
    filterCatalog();
    lastCategory = typeof saved.category === 'string' ? saved.category : '';
    const card = [...root.querySelectorAll('[data-category-key]')].find(item => item.dataset.categoryKey === lastCategory);
    Promise.resolve(document.fonts?.ready).then(() => {
      window.requestAnimationFrame(() => {
        card?.focus({ preventScroll: true });
        window.scrollTo({ top: Math.min(saved.top, document.documentElement.scrollHeight - window.innerHeight), behavior: 'instant' });
      });
    });
  }
  window.addEventListener('pageshow', restorePosition);
  restorePosition();
  window.addEventListener('storage', event => { if (event.key === storageKey) { selection = read(); update(); } });
  if (root.querySelector('[data-quote-sent]')) { selection = []; save(); }
  update();
})();
